import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Eye } from 'lucide-react'

const BotonVisualizar = ({ documentoId, className = '' }) => {
  const navigate = useNavigate()
  if (!documentoId) return null
  return (
    <button
      type="button"
      title="Visualizar documento"
      aria-label="Visualizar documento"
      onClick={() => navigate(`/ver-documento/${documentoId}`)}
      className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-gray-600 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-400 ${className}`}
    >
      <Eye className="h-5 w-5" aria-hidden="true" />
    </button>
  )
}

export default BotonVisualizar
